module.exports = "<div id=reason_refer class=\"u-row u-form-group\"> <div class=\"u-col-10 u-col-md-offset-1\"> <textarea class=u-form-control type=text data-bind=\"value: reason, attr: {maxlength: maxlength}\">\n    </textarea> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/confirmWithReason/index.html
// module id = 176
// module chunks = 144